import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom/dist";
import Table from "../../../../core/pagination/datatable";
// import TooltipIcons from "../../../../core/common/tooltip-content/tooltipIcons";
// import RefreshIcon from "../../../../core/common/tooltip-content/refresh";
// import CollapesIcon from "../../../../core/common/tooltip-content/collapes";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import { ROLL_CALL_API_BASE_URL } from "../RollCallConfig/RollCallConfig";
import { Select, Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  Bell,
  CornerRightUp,
  Eye,
  RotateCcw,
  UserX,
} from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import RollcallApplyLeave from "../Leaves/ApplyLeave";
import ResignRegistration from "../Registartions/Resign";
import SendMail from "./SendMail";
import Swal from "sweetalert2";

const RollcallEmployeesList = () => {
  const [dataLoading, setDataLoading] = useState(false);
  const [data, setData] = useState([]);
  const [empData, setEmpData] = useState([]);
  const [slectedDept, setSlectedDept] = useState("");
  const [slectedEmp, setSlectedEmp] = useState("");
  const [deptData, setDeptData] = useState([]);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [selectedRegId, setSelectedRegId] = useState(null);
  const [resignObj, setResignObj] = useState([]);
  const [mailObj, setMailObj] = useState("");
  console.log(mailObj);
  console.log(empData);

  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchDepartments = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/department/getdepartment?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch departments");
          }

          const data = await response.json();

          if (data.status) {
            setDeptData(data.ResultData);
          } else {
            console.error("Invalid department response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching departments:", error.message);
        }
      };
      fetchDepartments();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    const fetchEmployeeData = async () => {
      setDataLoading(true);
      if (tokenData && superIdData) {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/emp/getEmployee?superid=${superIdData}&departmentid=&regid=`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch employees");
          }

          const data = await response.json();
          if (data.status) {
            setData(data.ResultData || []);
            setEmpData(data.ResultData || []);
          } else {
            console.error("Error fetching employees:", data.ErrorMsg);
          }
        } catch (error) {
          console.error("Error fetching employees:", error);
        } finally {
          setDataLoading(false);
        }
      }
    };

    fetchEmployeeData();
  }, [superIdData, tokenData]);

  const departmentOptions =
    deptData &&
    deptData.map((item) => ({
      value: item.departmentid,
      label: item.Name,
    }));

  const empOptions =
    empData &&
    empData.map((item) => ({
      value: item.regid,
      label: item.UserName,
    }));

  const handleButtonClick = () => {
    if (tokenData && superIdData) {
      setDataLoading(true);

      const fetchEmployeeData = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/emp/getEmployee?superid=${superIdData}&departmentid=${slectedDept}&regid=${slectedEmp}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch employee data");
          }

          const responseData = await response.json();

          if (responseData.status) {
            setData(responseData.ResultData || []);
          } else {
            setData([]);
            console.error(
              "Failed to fetch employee data:",
              responseData.ErrorMsg
            );
          }
        } catch (error) {
          console.error("Error fetching employee data:", error);
        } finally {
          setDataLoading(false);
        }
      };

      fetchEmployeeData();
    }
  };

  const handleDeptChange = (value) => {
    setSlectedDept(value);
  };

  const handleEmpChange = (value) => {
    setSlectedEmp(value);
  };

  const filteredData = data.filter((item) => {
    return (
      (item.UserName && item.UserName.toLowerCase()) ||
      (item.Badge && item.Badge.toLowerCase()) ||
      (item.Mobile && item.Mobile.toString()) ||
      (item.branchname && item.branchname.toLowerCase()) ||
      (item.Departmentname && item.Departmentname.toLowerCase())
    );
  });

  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      sorter: (a, b) => a.sno - b.sno,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Bio ID",
      dataIndex: "CardId",

      sorter: (a, b) => a.CardId?.length - b.CardId?.length,
      render: (text) => text || "N/A",
    },
    {
      title: "Badge",
      dataIndex: "Badge",
      sorter: (a, b) => a.Badge?.length - b.Badge?.length,
      render: (text) => text || "N/A",
    },
    {
      title: "Name",
      dataIndex: "UserName",
      sorter: (a, b) => a.UserName?.length - b.UserName?.length,
      render: (text, record) => {
        const handleClick = () => {
          navigate("/rollcall/additional-details", {
            state: { regid: record.regid },
          });
        };

        return (
          <span
            title={text}
            onClick={handleClick}
            style={{ cursor: "pointer" }}
          >
            {text?.length > 11 ? `${text.substring(0, 11)}...` : text}
          </span>
        );
      },
    },
    {
      title: "Mobile",
      dataIndex: "Mobile",
      sorter: (a, b) => a.Mobile?.length - b.Mobile?.length,
      render: (text) => text || "N/A",
    },
    {
      title: "DOB",
      dataIndex: "DateOfBirth",
      sorter: (a, b) => new Date(a.DateOfBirth) - new Date(b.DateOfBirth),
      render: (text) => formatDate(text),
    },
    {
      title: "Role",
      dataIndex: "Designation",
      sorter: (a, b) => a.Designation?.length - b.Designation?.length,
      render: (text) => (
        <span title={text}>
          {text?.length > 13 ? `${text.substring(0, 13)}...` : text}
        </span>
      ),
    },
    {
      title: "Branch",
      dataIndex: "branchname",
      sorter: (a, b) =>
        (a.branchname?.length || 0) - (b.branchname?.length || 0),
      render: (text) => (
        <span title={text}>
          {text?.length > 10 ? `${text.substring(0, 10)}...` : text}
        </span>
      ),
    },
    {
      title: "Department",
      dataIndex: "Departmentname",
      sorter: (a, b) => a.Departmentname?.length - b.Departmentname?.length,
      render: (text) => (
        <span title={text}>
          {text?.length > 13 ? `${text.substring(0, 13)}...` : text}
        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <>
          <Link
            className="action-set"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v" aria-hidden="true" />
          </Link>
          <ul className="dropdown-menu">
            <li>
              <button
                className="dropdown-item"
                onClick={() => {
                  navigate("/rollcall/additional-details", {
                    state: { regid: record.regid },
                  });
                }}
              >
                <Eye className="info-img text-info me-2" />
                View
              </button>
            </li>
            <li>
              <Link
                to="#"
                className="dropdown-item"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightApplyLeave"
                aria-controls="offcanvasRightApplyLeave"
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedRegId(record.regid);
                }}
              >
                <CornerRightUp className="info-img text-success"></CornerRightUp>
                Apply Leave
              </Link>
            </li>
            <li>
              {/* <Link
                to="#"
                className="dropdown-item"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightSendNotification"
                aria-controls="offcanvasRightSendNotification"
                onClick={() => {
                  setMailObj(record);
                }}
              >
                <Bell className="info-img text-dark"></Bell>
                Send Notification
              </Link> */}
              {record.emailid && record.emailid.trim() !== "" ? (
                <Link
                  to="#"
                  className="dropdown-item"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightSendNotification"
                  aria-controls="offcanvasRightSendNotification"
                  onClick={() => {
                    setMailObj(record);
                  }}
                >
                  <Bell className="info-img text-dark" />
                  Send Notification
                </Link>
              ) : (
                <Link
                  to="#"
                  className="dropdown-item"
                  onClick={(e) => {
                    e.preventDefault();
                    Swal.fire({
                      icon: "warning",
                      title: "No Email Found",
                      text: "This employee does not have a valid email address.",
                      confirmButtonColor: "#FE9F43",
                    });
                  }}
                >
                  <Bell className="info-img text-dark" />
                  Send Notification
                </Link>
              )}
            </li>
            <li>
              <Link
                to=""
                className="dropdown-item"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightResignReg"
                aria-controls="offcanvasRightResignReg"
                onClick={() => setResignObj(record)}
              >
                <UserX className="info-img text-warning" />
                Resign
              </Link>
            </li>
          </ul>
        </>
      ),
    },
  ];

  const handleReload = () => {
    window.location.reload();
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleDownloadExcel = () => {
    if (filteredData && filteredData.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();
    const wsData = filteredData.map((item, index) => ({
      "S.No": index + 1,
      "Biometric ID": item.CardId || "N/A",
      // "Badge": item.Badge || "N/A",
      Name: item.UserName || "N/A",
      Mobile: item.Mobile || "N/A",
      DOB: formatDate(item.DateOfBirth) || "N/A",
      Designation: item.Designation || "N/A",
      Branch: item.branchname || "N/A",
      Department: item.Departmentname || "N/A",
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Employee Data");
    XLSX.writeFile(wb, "Employee_Data.xlsx");
  };

  const generatePDF = () => {
    if (filteredData && filteredData?.length === 0) {
      return;
    }

    const doc = new jsPDF();
    doc.text("Employee Report", 14, 10);

    const tableColumn = [
      "S.No",
      "Biometric ID",
      "Badge",
      "Name",
      "Mobile",
      "DOB",
      "Designation",
      "Branch",
      "Department",
    ];
    const tableRows = filteredData.map((item, index) => [
      index + 1,
      item.CardId || "N/A",
      item.Badge || "N/A",
      item.UserName || "N/A",
      item.Mobile || "N/A",
      formatDate(item.DateOfBirth) || "N/A",
      item.Designation || "N/A",
      item.branchname || "N/A",
      item.Departmentname || "N/A",
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows });
    doc.save("Employee_Data.pdf");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Employees
                    </h4>
                  </ol>
                </nav>
                <h6>Manage your terminated employees</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link onClick={generatePDF}>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    onClick={handleDownloadExcel}
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>

              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              {/* <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li> */}
            </ul>
            {/* <div className="page-btn">
                            <Link
                                to="#"
                                className="btn btn-primary"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasRightAddReg"
                                aria-controls="offcanvasRightAddReg"
                            >
                                <i className='ti ti-circle-plus'></i>
                            </Link>
                        </div> */}
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set mb-4">
                {/* <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div> */}
              </div>
              <div className="d-flex right-content align-items-end ">
                <div className="">
                  {/* <label className="form-label">Employee</label> */}
                  <div
                    className="form-control p-0 border-0"
                    style={{ width: 200 }}
                  >
                    <Select
                      showSearch
                      placeholder="Choose Employee"
                      value={slectedEmp || undefined}
                      onChange={handleEmpChange}
                      filterOption={(input, option) =>
                        option?.label
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={empOptions}
                      style={{ width: 170, height: 37 }}
                    />
                  </div>
                </div>
                <div className="">
                  {/* <label className="form-label">Department</label> */}
                  <div
                    className="form-control p-0 border-0"
                    style={{ width: 200 }}
                  >
                    <Select
                      showSearch
                      placeholder="Choose Department"
                      value={slectedDept || undefined}
                      onChange={handleDeptChange}
                      filterOption={(input, option) =>
                        option?.label
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={departmentOptions}
                      style={{ width: 170, height: 37 }}
                    />
                  </div>
                </div>
                <div className=" ">
                  <button
                    className="btn btn-primary"
                    onClick={handleButtonClick}
                  >
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                  </button>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive brand-table">
                {dataLoading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : (
                  <div className="table-responsive brand-table">
                    <Table columns={columns} dataSource={filteredData} />
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
        <CommonFooter />
      </div>

      <RollcallApplyLeave selectedRegId={selectedRegId} />
      <ResignRegistration resignObj={resignObj} />
      <SendMail mailObj={mailObj} />
    </div>
  );
};

export default RollcallEmployeesList;
